import { render, staticRenderFns } from "./ed-class-schedule-remove-block-modal.component.vue?vue&type=template&id=bd81828a&scoped=true&"
import script from "./ed-class-schedule-remove-block-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-schedule-remove-block-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-schedule-remove-block-modal.component.scss?vue&type=style&index=0&id=bd81828a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd81828a",
  null
  
)

export default component.exports